import { Unsubscribe } from 'firebase/firestore';

const subscriptions: Unsubscribe[] = [];

export const clearSubscriptions = () => {
  const unsubscribe = subscriptions.pop();
  if (!unsubscribe) {
    return;
  }
  unsubscribe();
  clearSubscriptions();
};

export const addSubscription = (unsubscribe: Unsubscribe) => {
  subscriptions.push(unsubscribe);
};
